<template>
  <div class="content">
    <div class="noticeLine"><i class="el-icon-warning"></i>预览以造像时代提供的默认名片为例，仅作示意；模块名称设置后，将在您企业名下的所有名片页生效，请谨慎操作。</div>
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" label-width="200px" :rules="rules" :model="ruleForm">
          <el-form-item label="模块一">
            <el-input type="text" :disabled="true" class="w340" value="名片信息" size="small"></el-input>
            <span class="wordFrom">该默认名称不在首页显示,无需编辑</span>
          </el-form-item>
          <div v-for="(item,index) in formLable" class="moduleList" :key="index">
            <el-form-item :label="item" :prop="'module_'+index">
              <div class="from_item">
                <el-input type="text" class="w340" maxlength="12" show-word-limit v-model="ruleForm['module_'+index]"
                          size="small"></el-input>
                <span class="btn_blue_span" @click="defultModuleVal(index)">恢复默认</span>
              </div>
            </el-form-item>
            <div class="moduleList">
              <el-form-item v-if="defultVal[index][1]" :prop="'module_'+index+'_'+1" label-width="260px">
                <div class="from_item">
                  <el-input type="text" class="w280" maxlength="12" show-word-limit
                            v-model="ruleForm['module_'+index+'_'+1]"
                            size="small"></el-input>
                  <span class="btn_blue_span" @click="defultModuleVal(index,1)">恢复默认</span>
                </div>
              </el-form-item>
            </div>
          </div>
          <el-form-item>
            <el-button type="primary" size="small" @click="submitForm('form')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="preview_wrap" style="background-color:white;">
        <div class="cardtitle_preview"  style="background-color:white;">
          <div class="box">
            <p class="box-p">
              <span class="box_title">{{ruleForm['module_0']}}</span>
            </p>
            <img src="/static/img/myperson.jpg" alt>
          </div>
          <div class="box">
            <p class="box-p">
              <span class="box_title">{{ruleForm['module_1']}}</span>
            </p>
            <img src="/static/img/mycompany.jpg" alt>
          </div>
          <div class="box">
            <p class="box-p">
              <span class="box_title">{{ruleForm['module_2']}}</span>
              <span class="more">
              {{ruleForm['module_2_1']}}
              <i class="el-icon-arrow-right"></i>
            </span>
            </p>
            <img src="/static/img/myproduct.jpg" alt>
          </div>
          <!--<div class="box">-->
            <!--<p class="box-p">-->
              <!--<span class="box_title">{{ruleForm['module_3']}}</span>-->
              <!--<span class="more">-->
              <!--{{ruleForm['module_3_1']}}-->
              <!--<i class="el-icon-arrow-right"></i>-->
            <!--</span>-->
            <!--</p>-->
            <!--<img src="/static/img/module/module03.jpg" alt>-->
          <!--</div>-->
          <div class="box">
            <p class="box-p">
              <span class="box_title">{{ruleForm['module_4']}}</span>
            </p>
            <img src="/static/img/myvideo.jpg" alt>
          </div>
          <div class="box">
            <p class="box-p">
              <span class="box_title">{{ruleForm['module_5']}}</span>
              <span class="more">
              {{ruleForm['module_5_1']}}
              <i class="el-icon-arrow-right"></i>
            </span>
            </p>
            <img src="/static/img/mypro1.jpg" alt>
          </div>
          <div class="box">
            <p class="box-p">
              <span class="box_title">{{ruleForm['module_6']}}</span>
            </p>
            <img src="/static/img/mypro.jpg" alt>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // TA的简介，TA的企业，TA的商品（有更多），TA的同事（有更多），TA的视频， TA的动态（有更多），TA的图片 默认值
  import api from "@/api.js"

  export default {
    name: "cardTitle",
    data() {
      return {
        formLable: ['模块二', '模块三', '模块四', '模块五', '模块六', '模块七' , '模块八'], //
        defultVal: [
          ['TA的简介'],
          ['TA的企业'],
          ['TA的商品', '更多'],
          ['TA的同事', '更多'],
          ['TA的视频'],
          ['TA的动态', '更多'],
          ['TA的图片']
        ],
        ruleForm: {},
        rules: {},
        responVal: null
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.companyadmin_get_module, {})
            .then(response => {
              if (response.data.code == 0) {
                let number = ['二', '三', '四', '五', '六', '七', '八']
                let ruleForm = {}
                let rules = {}

                for (let i in response.data.module_name) {
                  for (let j in response.data.module_name[i].values) {
                    let rules_list = {}
                    let option = {required: true, message: '', trigger: 'change'} //请输入模块二名称
                    if (Number(j) === 0) {
                      ruleForm['module_' + i] = response.data.module_name[i].values[j]
                      option.message = '请输入模块' + number[i] + '名称'
                      rules['module_' + i] = option
                    } else {
                      ruleForm['module_' + i + '_' + j] = response.data.module_name[i].values[j]
                      option.message = '请输入模块' + number[i] + '下级名称'
                      rules['module_' + i + '_' + j] = option
                    }
                  }
                }
                this.ruleForm = ruleForm
                this.rules = rules
                this.responVal = response.data.module_name
              } else {
              }
            })
            .catch(response => {
            });
      },
      defultModuleVal(index, line) {
        let name
        if (line) {
          name = 'module_' + index + '_' + 1
          this.ruleForm[name] = this.defultVal[index][1]
        } else {
          name = 'module_' + index
          this.ruleForm[name] = this.defultVal[index][0]
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitFormRespon()
          } else {
            this.$message.error('请填写相应名称');
            return false;
          }
        });
      },
      submitFormRespon() {
        let list = [];
        for (let i in this.ruleForm) {
          let list_i = [];
          let option = i.split('_');
          if (option[2]) {
            list[option[1]][1] = this.ruleForm[i]
          } else {
            list_i[0] = this.ruleForm[i]
            list.push(list_i)
          }
        }
        for (let i in list) {
          this.responVal[i].values = list[i]
        }

        this.axios
            .post(api.companyadmin_set_module, {module_name: this.responVal})
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '设置成功！',
                });
              } 
            })
            .catch(response => {
            });
      }
    }
  };
</script>
